angular.module('jv.AuthApps.Namespace', [])
    .value('AuthAppsNS', 'authorizedApps');

angular.module('jv.AuthApps.Fac', ['jv.AuthApps.Transformations', 'jv.AuthApps.Namespace','jv.getDeferred'])
    .value('AuthAppsUrl', '/admin/action/myAccount/authapps/status?readMode=1')
    .value('noop',angular.noop)
    .value('AuthAppsPostKey', 'AuthAppPostUrlKey')
    .factory('AuthAppsFac', ['$http', '$q','AuthAppsUrl', 'getDeferred', 'AuthAppsGETTransform', 'noop', AuthAppsFac])
    .factory('AuthAppsFacPost', ['$http', '$q','AuthAppsPostKey', 'getDeferred', 'noop', 'AuthAppsPOSTTransform', AuthAppsFac]);

function formPostUrl(platformId, string) {
    if(string === 'AuthAppPostUrlKey'){
        return '/admin/action/myAccount/authapps/'+platformId+'/save';
    }
    return string;

}

function AuthAppsFac($http,$q, url, getDeferredService, transformGET, transformPOST) {
    return function(pId, isFastRead, saveData) {
        var deferred = $q.defer();
        var transformPOSTData;
        var postUrl=formPostUrl(pId,url);
        var FAST_READ_QS = '?readMode=0';

        if(angular.isDefined(saveData)) {
            transformPOSTData=transformPOST(pId,saveData);
            if(!$.isEmptyObject(transformPOSTData)){
                $http({
                    url:postUrl,
                    method:'POST',
                    data:$.param(transformPOSTData),
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'}
                }).then(function(response) {
                if(response.data.msgInfo === 200) {
                    // Information saved
                    deferred.resolve();
                } else {
                    deferred.reject(response.data.msgInfo);
                }
            }, function(errorCode) {
                deferred.reject(errorCode);
            });
            }else{
                //No Data changes to Save
                deferred.reject(0);
            }

        } else {
            var getUrl = angular.copy(url);
            if(isFastRead && url.indexOf(FAST_READ_QS) < 0){
                getUrl += FAST_READ_QS;
            }
            $http.get(getUrl).then(function(response) {
                if(response.data) {
                    deferred.resolve(transformGET(response.data));
                } else {
                    deferred.reject(response.data.msgError || 'Server Error');
                }
            }, function(errorCode) {
                deferred.reject(errorCode);
            });
        }


        return deferred.promise;
    };
}
